var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3616",
    "data-name": "Group 3616",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    fill: "#fff4ea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "umbrella",
    d: "M23.717,9.549A12.834,12.834,0,0,0,13,2.043V1a1,1,0,1,0-2,0V2.043A12.843,12.843,0,0,0,.267,9.549a3.945,3.945,0,0,0,.4,3.682A4.015,4.015,0,0,0,4,15h7v6a1,1,0,1,1-2,0,1,1,0,0,0-2,0,3,3,0,0,0,6,0V15h6.983a4.017,4.017,0,0,0,3.329-1.769,3.948,3.948,0,0,0,.405-3.682Z",
    transform: "translate(18.508 17.5)",
    fill: "#ffa700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.e66832e4f634f28bf65c92f2ade2beda.svg";
export { ForwardRef as ReactComponent };